





























import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { IBudget, IUserData } from "@/vuex/modules/coupon/interfaces";
import { Action, Mutation } from "vuex-class";
import DataBudget from "../components/DataBudget.vue";
import DataIntegrator from "../components/DataIntegrator.vue";
import FormBudget from "../components/FormBudget.vue";
import FormCoupon from "../components/FormCoupon.vue";

@Component({
  components: {
    DataBudget,
    FormBudget,
    FormCoupon,
    DataIntegrator,
  },
})
export default class ViewNewCoupon extends Vue {
  @Prop() readonly session!: string;

  show = false;
  overlay = true;

  @Mutation("setBudget", { namespace: "coupon" }) setBudget!: (
    parmas: IBudget
  ) => void;

  @Mutation("setExistCoupon", { namespace: "coupon" }) setExistCoupon!: (
    param: boolean
  ) => void;

  @Mutation("setUserData", { namespace: "coupon" }) setUserData!: (
    params: IUserData
  ) => void;

  @Action("getSessionUser", { namespace: "coupon" }) getSessionUser!: (
    session: string
  ) => Promise<boolean>;

  async mounted(): Promise<void> {
    const userData: IUserData = {
      role: 0,
      session: this.session,
      rca_id: 0,
    };

    await this.getSessionUser(userData.session).then((response) => {
      if (response) {
        this.show = true;
        this.overlay = false;
      } else {
        this.$router.replace("/");
      }
    });

    this.setExistCoupon(true);
    const params: IBudget = {
      id: "",
      totalDiscount: 0,
      couponsActive: [],
      transferValue: 0,
      equipamentValue: 0,
      idIntegrator: 0,
      value: 0.0,
      discountMaxBrl: 0.0,
      discountMaxPercent: 0,
      consultantName: "Nome do Consultor",
      integratorName: "Nome do Integrador",
      fantasyIntegratorName: "Nome Fantasia",
      reasonIntegratorName: "Razão Social",
      amountInverters: 0,
      powerInverter: 0,
      brandInverter: "Marca do inversor",
      brandPanel: "Marca do painel",
      powerPanel: 0,
      amountPanel: 0,
      powerSystem: 0,
      typeStructure: "Estrutura",
      deliveryLocale: "Local de entrega",
      generators: [],
      discountsActive: 0,
      inGroup: false
    };
    this.setBudget(params);
  }
}
